import { StarIcon } from '@ui/icons/Star.icon'
import { StarFilledIcon } from '@ui/icons/StarFilled.icon'

export const normalizeSymbols = (symbols: string[]): string[] =>
  Array.from(new Set(symbols.map((item) => item.trim()).filter((item) => item !== '')))

export const getFavoriteIcon = (isFavorite?: boolean) =>
  ({
    icon: isFavorite ? StarFilledIcon : StarIcon,
    color: isFavorite ? 'text-warning-med-em' : 'text-low-em',
  } as const)

export const isFavoriteInstrument = (
  symbol?: string | null,
  favoriteSymbols?: string[]
): boolean => {
  if (!symbol) {
    return false
  }

  return !!favoriteSymbols?.includes(symbol)
}
